<template>
  <v-row dense align="center" class="horario-dia-filtro">
    <v-col cols="12" sm="8" md="5" lg="4">
      <v-btn
        class="horario-dia-filtro__date-btn"
        color="primary"
        outlined
        @click="dialogDia = true"
      >
        <v-icon left small>mdi-calendar</v-icon>
        {{ dataLabel }}
      </v-btn>
    </v-col>

    <v-col cols="12" sm="auto" class="horario-dia-filtro__actions">
      <v-btn color="primary" :disabled="botaoDesabilitado" @click="buscar">
        <v-icon left small>mdi-magnify</v-icon>
        Buscar
      </v-btn>
    </v-col>

    <v-dialog v-model="dialogDia" max-width="450">
      <v-card>
        <v-card-title class="text-h5">Selecionar data</v-card-title>

        <v-card-text>
          <v-row justify="center" class="mt-4">
            <v-date-picker v-model="dataInterna"></v-date-picker>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="dialogDia = false">Cancelar</v-btn>
          <v-btn color="green darken-1" text :disabled="!dataInterna" @click="aplicarData">
            Aplicar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "HorarioDiaFiltro",
  props: {
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogDia: false,
      dataInterna: this.value,
    };
  },
  computed: {
    botaoDesabilitado() {
      return this.disabled || !this.value;
    },
    dataLabel() {
      if (!this.value) return "Selecionar data";
      return this.formatarData(this.value);
    },
  },
  watch: {
    value(value) {
      this.dataInterna = value;
    },
  },
  methods: {
    aplicarData() {
      this.$emit("input", this.dataInterna);
      this.dialogDia = false;
    },
    buscar() {
      if (this.botaoDesabilitado) return;
      this.$emit("buscar");
    },
    formatarData(data) {
      if (!data) return "";
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
  },
};
</script>

<style scoped>
.horario-dia-filtro {
  margin: 0;
}

.horario-dia-filtro__date-btn {
  min-width: 190px;
  justify-content: flex-start;
  width: 100%;
}

.horario-dia-filtro__actions {
  display: flex;
  align-items: center;
}

@media (max-width: 599px) {
  .horario-dia-filtro__actions .v-btn {
    width: 100%;
  }
}
</style>
